<template>
    <div class="safety">
        <router-view />
    </div>
</template>

<script>
export default {
	name: "Safety"
};
</script>
